import React from "react";
import { Chip, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

interface TinyValueComponentProps {
  label?: string;
  value: string;
  clipboard?: boolean;
  color?: any;
  autocolor?: boolean;
}

// Define 16 pastel colors
const pastelColors = [
  "#FFB3BA",
  "#FFDFBA",
  "#FFFFBA",
  "#BAFFC9",
  "#BAE1FF",
  "#E6B0AA",
  "#D7BDE2",
  "#A9CCE3",
  "#A3E4D7",
  "#F9E79F",
  "#F5CBA7",
  "#D5DBDB",
  "#FADBD8",
  "#D4E6F1",
  "#D0ECE7",
  "#FDEDEC",
];

// Function to get a color based on the value
const getColorFromValue = (value: string) => {
  const hash = Array.from(value).reduce(
    (acc, char) => acc + char.charCodeAt(0),
    0
  );
  return pastelColors[hash % pastelColors.length]; // Ensures same value gets the same color
};

export const TinyValueComponent: React.FC<TinyValueComponentProps> = ({
  label,
  value,
  clipboard,
  color,
  autocolor,
}) => {
  const handleCopy = (event: React.MouseEvent) => {
    event.stopPropagation();
    navigator.clipboard.writeText(value);
  };

  const chipColor = autocolor ? getColorFromValue(value) : color;

  return (
    <Chip
      size="small"
      label={
        <Tooltip title="Copy to clipboard">
          <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <b>{label}</b>
            {value}
            {clipboard && (
              <ContentCopyIcon sx={{ fontSize: 12, opacity: 0.6 }} />
            )}
          </span>
        </Tooltip>
      }
      onClick={handleCopy}
      sx={{
        fontSize: "0.6rem",
        height: 16,
        padding: "0 4px",
        minWidth: "auto",
        cursor: "pointer",
        backgroundColor: chipColor,
        color: "black", // Ensuring contrast for readability
      }}
    />
  );
};
